import { connect } from 'react-redux'
import TimeoutOverlay from '../components/TimeoutOverlayView'
import {closeTimeoutPopup, openTimeoutPopup} from "../../../../store/timer";
import {getCountdown} from '../modules/timer'

const mapDispatchToProps = {
  openTimeoutPopup,
  closeTimeoutPopup
};

const mapStateToProps = (state) => ({
  showTimeoutPopup: state.timer.timeout_popup,
  countdown: getCountdown(),
});


export default connect(mapStateToProps, mapDispatchToProps)(TimeoutOverlay)


// WEBPACK FOOTER //
// ./src/components/shared/TimeoutOverlay/containers/TimeoutOverlayContainer.js